import React, { Component } from "react";
import { Table, Tag, Alert, Spin } from "antd";
import axios from "axios";
import { textoTraslados } from "./xmlConceptosHelpers";
import AltaProveedorRapida from "../Proveedores/AltaProveedorRapida";

// Tabla de solo lectura: muestra los conceptos de un XML y, si el proveedor ya está
// registrado, si cada concepto ya tiene un insumo relacionado o no (via insumos/procesarXml,
// el mismo endpoint que usa el flujo de alta de facturas). No permite relacionar conceptos
// aquí — eso solo se hace en el wizard "Importar Facturas XML" (relación en lote).
class ConceptosXmlTable extends Component {
  state = { loading: false, matchPorIndice: {} };

  componentDidMount() {
    this.consultarRelaciones();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.proveedorId !== this.props.proveedorId || prevProps.conceptos !== this.props.conceptos) {
      this.consultarRelaciones();
    }
  }

  consultarRelaciones() {
    const { empresaId, proveedorId, conceptos, headersToken } = this.props;
    if (!proveedorId || !conceptos || !conceptos.length) {
      this.setState({ matchPorIndice: {} });
      return;
    }

    this.setState({ loading: true });
    const conceptosConIndice = conceptos.map((c, i) => ({ ...c, _i: i }));

    axios
      .post("insumos/procesarXml", { empresaId, proveedorId, conceptos: conceptosConIndice }, { headers: headersToken })
      .then((res) => {
        const matchPorIndice = {};
        if (res.data.success === 2) {
          (res.data.insumos || []).forEach((item) => {
            matchPorIndice[item._i] = item.insumoId ? item.insumoCompleto : null;
          });
        }
        this.setState({ loading: false, matchPorIndice });
      })
      .catch(() => this.setState({ loading: false, matchPorIndice: {} }));
  }

  render() {
    const { proveedorId, proveedorRfc, proveedorNombre, monedaAbrev, todasTiposDeProveedor, todasMonedas, conceptos, empresaId, headersToken, onProveedorAlta } = this.props;

    if (!proveedorId) {
      return (
        <Alert
          type="warning"
          showIcon
          message="El proveedor de este XML no está registrado en el catálogo"
          description={
            <>
              <p>No se puede verificar si sus conceptos ya están relacionados a un insumo hasta registrarlo:</p>
              <AltaProveedorRapida
                empresaId={empresaId}
                headersToken={headersToken}
                rfc={proveedorRfc}
                nombre={proveedorNombre}
                monedaAbrev={monedaAbrev}
                todasTiposDeProveedor={todasTiposDeProveedor}
                todasMonedas={todasMonedas}
                onAlta={onProveedorAlta}
              />
            </>
          }
        />
      );
    }

    const dataSource = (conceptos || []).map((c, i) => ({ ...c, key: i, insumoMatch: this.state.matchPorIndice[i] }));

    return (
      <Spin spinning={this.state.loading}>
        <Table
          size="small"
          dataSource={dataSource}
          pagination={false}
          columns={[
            { title: "Descripción", dataIndex: "descripcion" },
            { title: "Código", dataIndex: "codigo" },
            { title: "Cantidad", dataIndex: "cantidad", align: "right" },
            {
              title: "Precio unitario",
              dataIndex: "precioUnitario",
              align: "right",
              render: (v) => Number(v || 0).toFixed(2),
            },
            { title: "Impuestos", render: (_, r) => textoTraslados(r.traslados) },
            {
              title: "Insumo relacionado",
              render: (_, r) =>
                r.insumoMatch ? (
                  <Tag color="green">{r.insumoMatch.stringBuscar}</Tag>
                ) : (
                  <Tag color="gold">Sin relacionar</Tag>
                ),
            },
          ]}
        />
      </Spin>
    );
  }
}

export default ConceptosXmlTable;
